<template>
  <div class="basePanel">
    <div class="el-row basePanel_div">
      <TaskList
        ref="taskList"
        :tableHeight="tableHeight +(templateQuery.TEMPTYPE == 0?0:32)"
        v-if="selectRadioType==='列表'"
        @rowContextmenu="rowContextmenu"
        @createdTalk="createdTalk"
        @TaskSummary="TaskSummary"
        @urgeTask="urgeTask"
        @addWorkRecord="addWorkRecord"
        @focusTask="focusTask"
        @Notification="Notification"
        :contextMenuData="contextMenuData"
      ></TaskList>

      <!-- <TaskCardList :style="{height: listHeight+'px' ,overflow: auto}" v-else @rowContextmenu="rowContextmenu" @TaskSummary="TaskSummary" @createdTalk="createdTalk" @urgeTask="urgeTask" @addWorkRecord="addWorkRecord" @focusTask="focusTask" @Notification="Notification"
			    :contextMenuData="contextMenuData">
      </TaskCardList>-->
    </div>
    <div class="el-row" v-if="templateQuery.TEMPTYPE == 0 && isPagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="[10, 30, 50, 100]"
        :layout="pageLayout"
        :total="totalCount"
      >
        <el-select v-model="$store.state.task.pageSize" size="mini" @change="pageSizeChange">
          <el-option
            v-for="item in pageSizes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-pagination>
    </div>
    <el-dialog
      title="选择关注分组"
      append-to-body
      :visible.sync="centerDialogVisible"
      width="505px"
      height="270px"
      center
    >
      <el-radio-group v-model="radio" @change="changeStyle">
        <el-radio :label="1">新建分组</el-radio>
        <el-radio :label="2">选择分组</el-radio>
        <el-radio :label="3">未分组</el-radio>
      </el-radio-group>
      <div style="margin-top: 30px; margin-left: 40px;" class="inputWithSelect">
        <el-autocomplete
          :fetch-suggestions="querySearch"
          @select="handleSelect"
          :disabled="disabledinput"
          v-model.trim="input"
          placeholder="请输入分组名称"
          style="width: 90%;"
        >
          <template slot-scope="{ item }">
            <div class="name">{{ item.NAME }}</div>
          </template>
        </el-autocomplete>
      </div>
    </el-dialog>
  </div>
</template>
					<el-select v-model="select" style="width: 100px;" slot="prepend" placeholder="等级">
						<el-option label="一级" value="1"></el-option>
						<el-option label="二级" value="2"></el-option>
						<el-option label="三级" value="3"></el-option>
					</el-select>
				</el-autocomplete>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button style="margin-left: 70px;" type="primary" @click="submitfocusdetail">确 定</el-button>
			</span>
		</el-dialog>
		<taskListDialog ref="taskListDialog"></taskListDialog>
		<el-dialog id="myDdialog" :title="summaryTaskTitle" :visible.sync="summaryTaskDialogVisible" width="800px" center>
			<div class="mySummaryTip">
				<el-row style="padding-left: 18px;">
					<el-col :span="24">
						<span style="font-size: 18px; ">任务编号:&nbsp;&nbsp;{{myTaskCode}}</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 5px;padding-left: 18px;">
					<el-col :span="24">
						<span style="font-size: 18px; ">任务标题:&nbsp;&nbsp;{{myTaskName}}</span>
					</el-col>
				</el-row>
			</div>
			<summaryTask :myRowData="myRowData" @ISCOMPLETED="checkIsCompleted" ref="summaryTask"></summaryTask>
			<span slot="footer" class="dialog-footer">
				<el-progress v-show="process!=0" :percentage='process'></el-progress>
							<el-row>
								<el-col :span="3" v-show="false">
								<el-checkbox v-model="ISCOMPLETED">保存至工作总结</el-checkbox>
								</el-col>
								<el-col :span="21">
								<el-button @click="summaryTaskDialogVisible = false">取 消</el-button>
   								<el-button type="primary" :disabled="submitDis" @click="toSummaryTask">{{submitBtn}}</el-button>
  								</el-col>
							</el-row>
							</span>
		</el-dialog>
		<el-dialog title="所有总结" :visible.sync="allSummaryVisible" top="5px" width="450px" center append-to-body>
			<el-scrollbar style="height: 100%;">
				<div style="height: 400px;">
					<el-row v-for="(c,index) in allSummary" :key="index" style="margin-top: 3px;">
						<el-col :span="24">
							<el-card :body-style="{ padding: '0px'}" shadow="hover">
								<div style="padding: 14px;">
									<div>
										<span>{{c.CREATEUSERNAME}}对此任务进行了总结</span>
										<div class="bottom clearfix">
											<table style="width:100%;">
												<tr>
													<td><time class="time">
														时间：
														{{timeFormat(c.CREATETIME)}}
													</time></td>
													<td style="width:90px;line-height:30px">
														<el-button type="text" class="button" style="color:#6aca5d" @click="lookDetail(c.CREATEUSERID)">点击查看</el-button>
													</td>
												</tr>
											</table>
										</div>
									</div>
								</div>
							</el-card>
						</el-col>
					</el-row>
				</div>
			</el-scrollbar>
			<span slot="footer" class="dialog-footer">
   				<el-button type="primary" @click="allSummaryVisible = false">关闭</el-button>
			</span>
		</el-dialog>
		<!--查看通知策略及通知结果-->
		<side-tags-record-dialog ref="SideTagsRecordDialog"></side-tags-record-dialog>
		<SelectTaskChatSession ref="selectTaskChatSession"></SelectTaskChatSession>
	</div>
</template>

<script>
import { getToken } from "../../../util/auth";
import axios from "axios";
import {
  ConstTask,
  urgeTask,
  AddConstGroupTask,
  getTaskListByParas,
  GetAllConstTaskGroup,
  getAllTaskSummaryByTaskId,
  saveTaskSummary,
  UploadFiles
} from "@/api/modules/basicData/task.js";
import { Linq, DateFormat, TimeFormat } from "@/util/common";
import TaskList from "./TaskList.vue";
import SelectTaskChatSession from "../Chat/SelectTaskChatSession.vue";
import TaskCardList from "./TaskCardList.vue";
import taskListDialog from "./taskListDialog.vue";
// import SideTagsRecordDialog from "./SideTagsRecordDialog.vue";
import summaryTask from "@/views/task/components/summaryTask.vue";
const cookieUser = getToken();
export default {
  name: "SideList",
  data() {
    return {
      searchParams: {
        KeyWord: "", //全文搜索关键字
        CreateUserId: "",
        ExcuteUserId: "",
        TaskState: "",
        ServerCenterId: "",
        Menu: "",
        TaskType: ""
      },
      pageLayout: "total, slot,prev, pager, next, jumper",
      pageSizes: [
        { label: "10条/页", value: 10 },
        { label: "30条/页", value: 30 },
        { label: "50条/页", value: 50 },
        { label: "100条/页", value: 100 },
        { label: "全部", value: 40 }
      ],
      summaryTaskDialogVisible: false,
      summaryTaskTitle: "任务总结",
      submitBtn: "保存草稿",
      submitDis: false,
      myTaskCode: "",
      myTaskName: "",
      process: 0,
      ISCOMPLETED: false,
      allSummaryVisible: false,
      allSummary: [],
      myRowData: {
        userId: "",
        taskId: "",
        taskState: 1
      },
      input: "",
      radio: 1,
      select: "1",
      groupID: "",
      grouplist: [],
      timeout: null,
      consttask: {
        TASKID: "",
        USERID: "",
        GROUPID: "",
        FOCUSDEGREE: ""
      },
      group: {
        USERID: "",
        USERNAME: "",
        NAME: ""
      },
      disabledinput: false,
      centerDialogVisible: false,
      selectRadioType: "列表",
      contextMenuData: {
        menuName: "taskList",
        axis: {
          x: null,
          y: null
        },
        data: null,
        menulists: this.$store.state.task.taskcontextMemu
      },
      listHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight - 1000 //（这里的240是减去表格上面导航和搜索条件的高度）
    };
  },
  props: {
    tableHeight: [Number, String],
    templateQuery: {
      type: Object,
      default: function() {
        return { TEMPTYPE: 0 };
      }
    },
    isPagination:{
      type: Boolean,
      default: true
    }
  },
  created() {
    var a = $(window).height();
    this.listHeight = a - 200;
    this.auto = "auto";
  },
  watch: {
    // 这里的定时器是为了优化，如果频繁调用window.onresize方法会造成页面卡顿，增加定时器会避免频繁调用window.onresize方法timer默认值设置为false，这里相当于一个按钮，防止频繁改变时引起卡顿
    listHeight(val) {
      if (!this.timer) {
        this.listHeight = val;
        this.timer = true;
        const that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  computed: {
    taskSource: function() {
      return this.$store.state.task.taskSource;
    },
    pageIndex: {
      get: function() {
        return this.$store.state.task.pageIndex;
      },
      set: function(val) {
        // this.$store.dispatch('changePageIndex', val,this.$store.state.task.type);
      }
    },
    pageSize: function() {
      return this.$store.state.task.pageSize;
    },
    totalCount: function() {
      return this.$store.state.task.totalCount;
    }
  },
  methods: {
    deleteResult(data) {
      this.$refs.taskList.deleteResult(data);
    },

    pageSizeChange(size) {
      if (size == 40) {
        this.$store.state.task.isInfiniteScroll = true;
        this.pageLayout = "total, slot";
      } else {
        this.$store.state.task.isInfiniteScroll = false;
        this.pageLayout = "total, slot,prev, pager, next, jumper";
      }
      this.$store.dispatch("changePageSize", {
        size: size,
        type: this.$store.state.task.type
      });
    },
    clearSelection() {
      this.$refs.taskList.clearSelection();
    },
    LuneceSearch() {
      if (this.searchParams.KeyWord) {
        let para = Object.assign({}, this.searchParams);
        this.$store.dispatch("changeLuneceTaskParas", para);
      }
    },
    lookDetail(userId) {
      //console.log(this.contextMenuData.data)
      this.submitDis = true;
      this.submitBtn = "已完成";
      this.myRowData.taskState = this.contextMenuData.data.STATE;
      this.myRowData.taskId = this.contextMenuData.data.ID;
      this.myRowData.Complete = true;
      let dds = "";
      if (
        this.contextMenuData.data.CONTENT != null &&
        this.contextMenuData.data.CONTENT != ""
      ) {
        let dd = this.contextMenuData.data.CONTENT.replace(/<\/?.+?>/g, "");
        dds = dd.replace(/ /g, ""); //dds为得到后的内容
      }
      this.myRowData.taskDescreption = dds;
      this.myRowData.taskName = this.contextMenuData.data.TASKNAME;
      this.myTaskCode = this.contextMenuData.data.INSTANCE;
      this.myTaskName = this.contextMenuData.data.TASKNAME;
      this.myRowData.userId = userId;
      this.summaryTaskDialogVisible = true;
    },
    querySearch(queryString, cb) {
      var grouplist = this.grouplist;
      var results = queryString
        ? grouplist.filter(this.createFilter(queryString))
        : grouplist;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return grouplist => {
        return (
          grouplist.NAME.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      this.groupID = item.ID;
    },
    rowContextmenu(info) {
      var x = info.x;
      var y = info.y;
      this.contextMenuData.data = info.data;
      var taskobjfocus = this.contextMenuData.data.MYFOCUSED;
      var storeMemu = this.$store.state.task.taskcontextMemu;
      var Index = null;
      // for (var i = 0; i < storeMemu.length; i++) {
      // 	if (storeMemu[i].btnName.indexOf("关注") > -1) {
      // 		Index = i;
      // 		break;
      // 	}
      // }
      // storeMemu[Index].btnName = (taskobjfocus ? '取消关注' : '设为关注任务');
      this.contextMenuData.axis = {
        x,
        y
      };
    },
    createdTalk() {
      //	alert("createdTalk" + this.contextMenuData.data.TASKNAME)
      this.$refs.selectTaskChatSession.initialSource(
        this.contextMenuData.data.ID
      );
    },
    checkIsCompleted(val) {
      this.ISCOMPLETED = val;
    },
    TaskSummary() {
      //打开总结
      if (this.contextMenuData.data.EXCUTEUSERID != cookieUser.userId) {
        this.$message({
          message: "请选择自己执行的任务进行总结",
          type: "warning"
        });
      } else {
        if (
          this.contextMenuData.data.STATE == 1 ||
          this.contextMenuData.data.STATE == 2
        ) {
          if (this.contextMenuData.data.HasSummary == false) {
            if (this.contextMenuData.data.STATE == 1) {
              this.submitBtn = "保存草稿";
            } else {
              this.submitBtn = "提交";
            }
            let dds = "";
            if (
              this.contextMenuData.data.CONTENT != null &&
              this.contextMenuData.data.CONTENT != ""
            ) {
              let dd = this.contextMenuData.data.CONTENT.replace(
                /<\/?.+?>/g,
                ""
              );
              dds = dd.replace(/ /g, ""); //dds为得到后的内容
            }
            this.myRowData.Complete = false;
            this.myRowData.taskState = this.contextMenuData.data.STATE;
            this.myRowData.taskId = this.contextMenuData.data.ID;
            this.myTaskCode = this.contextMenuData.data.INSTANCE;
            this.myTaskName = this.contextMenuData.data.TASKNAME;
            this.myRowData.taskDescreption = dds;
            this.myRowData.taskName = this.contextMenuData.data.TASKNAME;
            this.myRowData.userId = cookieUser.userId;
            this.submitDis = false;
            this.summaryTaskDialogVisible = true;
          } else {
            getAllTaskSummaryByTaskId(this.contextMenuData.data.ID).then(
              res => {
                this.allSummary = res;
                this.allSummaryVisible = true;
              }
            );
          }
        } else {
          this.$message({
            message: "当前任务状态无法总结",
            type: "warning"
          });
        }
      }
    },
    toSummaryTask() {
      //完成总结
      let summaryJson = this.$refs.summaryTask.summaryList;
      let isTrue = true;
      summaryJson.DetailList.forEach(c => {
        if (c.TITLE == "") {
          isTrue = false;
        }
        if (c.CONTENT == "") {
          isTrue = false;
        }
      });
      if (isTrue == false) {
        this.$message({
          message: "请填写标题或内容",
          type: "info"
        });
      } else {
        if (summaryJson.ID == "" || summaryJson.ID == null) {
          summaryJson.ID = this.newGuid(); //空的话是新数据，生成ID
        }
        var myDate = new Date();
        summaryJson.TASKID = this.contextMenuData.data.ID;
        summaryJson.CREATEUSERID = this.contextMenuData.data.EXCUTEUSERID;
        summaryJson.CREATEUSERNAME = this.contextMenuData.data.EXCUTEUSERNAME;
        summaryJson.CREATEDEPTID = this.contextMenuData.data.EXCUTEDEPTID;
        summaryJson.CREATEDEPTNAME = this.contextMenuData.data.EXCUTEDEPTNAME;
        summaryJson.CREATETIME = myDate.toLocaleString();
        if (this.contextMenuData.data.STATE == 1) {
          summaryJson.ISCOMPLETED = false;
        } else if (this.contextMenuData.data.STATE == 2) {
          summaryJson.ISCOMPLETED = true;
        }
        summaryJson.DetailList.forEach(c => {
          c.SUMMARYID = summaryJson.ID;
          if (c.ID == "" || c.ID == null) {
            //空的话是新数据，生成ID
            c.ID = this.newGuid();
          }
          c.DeviceList.forEach(dev => {
            //						dev.DEVICEID = dev.SocialId
            //						dev.DEVICENAME = dev.Name
            //						dev.DEVICETYPE = this.GetObjType(dev.Type)
            dev.SUMMARYDETAILID = c.ID;
            //						dev.SERIES = dev.Serial
            //						dev.LOCATION = dev.AreaName
          });
          c.OPobjectList.forEach(obj => {
            obj.SUMMARYDETAILID = c.ID;
            //						obj.OPOBJECTID = obj.SocialId
            //						obj.OPOBJECTNAME = obj.Name
          });
        });
        var _this = this;
        saveTaskSummary(summaryJson)
          .then(res => {
            if (res.ResultCode == 1) {
              let newFileLists = _this.$refs.summaryTask.newFileLists;
              for (var i = 0; i < summaryJson.DetailList.length; i++) {
                if (newFileLists[i].FileList.length > 0) {
                  _this.uploadFiles(
                    summaryJson.DetailList[i].ID,
                    newFileLists[i].FileList
                  );
                }
              }
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.summaryTaskDialogVisible = false;
            } else {
              this.$message({
                message: "保存出错",
                type: "warning"
              });
            }
          })
          .catch(err => {
            console.log("saveTaskSummary err");
          });
      }
    },
    uploadFiles(mainId, FileList) {
      //				let config = {
      //					headers: {
      //						'Content-Type': 'multipart/form-data'
      //					},
      //					onUploadProgress: (progressEvent) => {
      //						// 使用本地 progress 事件
      //						if(progressEvent.lengthComputable) {
      //							let num = Math.round((progressEvent.loaded / progressEvent.total) * 100)
      //							this.process = num // 使用某种 UI 进度条组件会用到的百分比
      //						}
      //					},
      //					method: "POST"
      //				}
      //let url = this.REPAIRAPI_ROOT + 'task/UploadFiles'
      let filesObj = {
        MainId: mainId,
        FileType: 11,
        Person: cookieUser
      };
      var formData = new FormData();
      if (FileList && FileList.length > 0) {
        for (var i = 0; i < FileList.length; i++) {
          formData.append(i.toString(), FileList[i]);
        }
      }
      var _this = this;
      formData.append("TaskFileUploadModel", JSON.stringify(filesObj));
      //axios.post(url, formData, config).then((res) => {
      UploadFiles(formData)
        .then(res => {})
        .catch(err => {
          console.log("saveTaskSummary err");
        });
    },
    timeFormat(time) {
      return TimeFormat(time);
    },
    GetObjType(type) {
      if (
        Linq.from([20, 31, 21, 22, 23]).firstOrDefault(s => s == type) != null
      )
        return 0;
      if (
        Linq.from([24, 25, 29, 12, 14]).firstOrDefault(s => s == type) != null
      )
        return 1;
      if (
        Linq.from([16, 33, 35, 37, 39]).firstOrDefault(s => s == type) != null
      )
        return 3;
      if (
        Linq.from([41, 43, 45, 47, 49]).firstOrDefault(s => s == type) != null
      )
        return 4;
      return -1; //error
    },
    newGuid() {
      var d = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    urgeTask() {
      // alert("urgeTask" + this.contextMenuData.data.TASKNAME)
      this.$prompt("请输入催办内容", "催办任务", {
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(({ value }) => {
        if (!value) {
          this.$message.info("请输入催办内容");
          return false;
        } else if (!this.trim(value)) {
          this.$message.info("请输入催办内容");
          return false;
        }
        urgeTask(this.contextMenuData.data.ID, value, cookieUser.userId).then(
          resultCode => {
            if (resultCode) {
              this.$message.success("催办成功");
            } else {
              this.$message.error("催办失败");
            }
          }
        );
      });
    },
    addWorkRecord() {
      this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
      this.$refs.SideTagsRecordDialog.addRecordRelation(
        this.contextMenuData.data.ID,
           this.contextMenuData.data.TASKNAME,
        0,
        this.contextMenuData.data.INSTANCE
      );
      // this.$refs.SideTagsRecordDialog.type = 1;
      // this.$refs.SideTagsRecordDialog.task = this.contextMenuData.data;
    },
    focusTask() {
      console.log(this.contextMenuData, "this.contextMenuData");
      var taskobj = this.contextMenuData.data;
      if (taskobj.MYFOCUSED) {
        // 取消关注
        ConstTask(
          taskobj.MYFOCUSED,
          this.$store.state.task.userId,
          taskobj.ID
        ).then(res => {
          this.$message({
            message: "已取消关注",
            type: "success"
          });
          // this.$store.commit('changePageIndex', 1);
          this.$store.dispatch("changeTaskSource");
        });
      } else {
        // 弹窗关注并选择关注分组.
        this.radio = 1;
        this.input = "";
        this.grouplist = [];
        this.select = "1";
        this.disabledinput = false;
        this.centerDialogVisible = true;
      }
    },
    changeStyle() {
      // 选择 关注任务 类型
      console.log(this.radio, "分组---0");
      this.grouplist = [];
      this.input = "";
      this.disabledinput = false;
      if (this.radio == 3) {
        this.disabledinput = true;
      } else if (this.radio == 2) {
        GetAllConstTaskGroup(this.$store.state.task.userId, this.input).then(
          res => {
            for (var i = 0; i < res.length; i++) {
              res[i].value = res[i].NAME;
            }
            this.grouplist = res;
          }
        );
      }
    },
    submitfocusdetail() {
      //提交分组详情
      var taskobj = this.contextMenuData.data;
      this.consttask.GROUPID = "";
      this.consttask.TASKID = taskobj.ID;
      this.consttask.FOCUSDEGREE = this.select;
      this.consttask.USERID = this.$store.state.task.userId; //反正每次都会覆盖.
      if (this.radio == 1) {
        //新建分组
        this.group.NAME = this.input;
        if (!this.input) {
          this.$message({
            message: "分组名不能为空",
            type: "warning"
          });
          return false; // 这样后面的代码就不会继续执行了
        } else {
          if (this.input.length < 65) {
            this.group.USERID = this.$store.state.task.userId;
            this.group.USERNAME = this.$store.state.task.userName;
            AddConstGroupTask(this.consttask, this.group).then(res => {
              this.GetStateCodeText(res);
            });
          } else {
            this.$message({
              message: "分组名不能过长",
              type: "warning"
            });
            return false;
          }
        }
      } else {
        if (this.radio == 2) {
          //选择已有分组
          this.consttask.GROUPID = this.groupID;
        }
        AddConstGroupTask(this.consttask).then(res => {
          this.GetStateCodeText(res);
        });
      }
      console.log(this.radio, "分组");
    },
    GetStateCodeText(rescode) {
      // 教你一个省代码的办法写.
      var text = "",
        type = "warning";
      switch (rescode) {
        case -2:
          text = "分组名称重复，请重新填写";
          break;
        case -1:
          text = "当前任务已经关注";
          break;
        case 1:
          text = "关注当前任务成功";
          type = "success";
          // this.$store.commit('changePageIndex', 1);
          this.$store.dispatch("changeTaskSource");
          this.centerDialogVisible = false;
          break;
        default:
          text = "关注当前任务失败";
          break;
      }
      this.$message({
        message: text,
        type: type
      }); //这样就短了.
    },
    Notification() {
      this.$refs.taskListDialog.dialogVisible = true;
      //alert("Notification" + this.contextMenuData.data.TASKNAME)
    },
    handleSizeChange(val) {
      // console.log('SizeChange',val);
      this.$store.dispatch("changePageSize", {
        size: val,
        type: this.$store.state.task.type
      });
    },
    handleCurrentChange(val) {
      // 				console.log('CurrentChange',val);
      // 				console.log('CurrentChange',this.$store.state.task.type);
      this.$store.dispatch("changePageIndex", {
        index: val,
        type: this.$store.state.task.type
      });
    },
    changeRadioSelect(newval) {
      this.selectType = newval;
    },
    changeCurTask(row) {
      console.log("返回值", row);
      // this.$parent.changeCurTask(row);
      this.$emit("changeCurTask", row);
      // this.curTask=row;
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.tableHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
        that.listHeight = window.tableHeight - 200;
      })();
    };
  },
  components: {
    TaskList,
    TaskCardList,
    // SideTagsRecordDialog,
    taskListDialog,
    summaryTask,
    SelectTaskChatSession
  }
};
</script>

<style scoped>
.mySummaryTip {
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
}
.time {
  font-size: 13px;
  color: #999;
}
.bottom {
  margin-top: 13px;
  line-height: 12px;
}
.topRow {
  height: 5px;
}
h3 {
  float: left;
  line-height: 0;
  margin-left: 21px;
  margin-top: 25px;
  color: #424242;
}
.topCard {
  float: right;
  margin-bottom: 7px;
  margin-right: 16px;
}
.search {
  float: right;
  width: 300px;
}
.basePanel {
  height: 100%;
}
.el-radio-group {
  margin-left: 20%;
}
#myDdialog {
  padding: 2px 25px 30px !important;
}
.el-row {
}
.basePanel_div {
  position: static;
}
</style>
